// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27����_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<g>\t\t<path d=%27M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3.7L12,3.3L9.3,9.6L5.9,6.1\t\t\tL5.1,6.9l4.5,4.5L13,3.7z%27/>\t</g></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27����_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27\t width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<g>\t\t<path d=%27M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3H5v1h8V3z M13,6H5v1h8V6z M13,9H5\t\t\tv1h8V9z%27/>\t</g></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27����_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<g>\t\t<path d=%27M11,6h-1v2h1V6z M8,6H7v2h1V6z M11,12h-1v2h1V12z M14,6h-1v2h1V6z M14,9h-1v2h1V9z M14,12h-1v2h1V12z M11,9h-1v2h1V9z\t\t\t M5,12H4v2h1V12z M8,9H7v2h1V9z M5,9H4v2h1V9z M15,3V1h-1v2H4V1H3v2H0v14h18V3H15z M17,16H1V4h16V16z M5,6H4v2h1V6z M8,12H7v2h1\t\t\tV12z%27/>\t</g></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27����_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<polygon points=%2711,2.3 8.3,8.6 4.9,5.1 4.1,5.9 8.6,10.4 12,2.7 \t%27/>\t<path d=%27M14,2V0H2v16h2v2h7.7l4.3-4.3V2H14z M3,1h10v10H9v4H3V1z M13,12v0.3L10.3,15H10v-3H13z M15,13.3L11.3,17H5v-1h5.7l3.3-3.3\t\tV3h1V13.3z%27/></g></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class^="hmi-j-"],
[class*=" hmi-j-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "hmi" !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    font-size: 24px;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.hmi-j--allpage:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.hmi-j-step-down:before {
    content: "\\e909";
}

.hmi-j-step-up:before {
    content: "\\e90a";
}

.hmi-j-up-down:before {
    content: "\\e90b";
}

.hmi-j-find:before {
    content: "\\e90c";
}

.hmi-j-full-screen:before {
    content: "\\e90d";
}

.hmi-j-filter:before {
    content: "\\e90e";
}

.hmi-j-legend:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.hmi-j-pause:before {
    content: "\\e910";
}

.hmi-j-play:before {
    content: "\\e911";
}

.hmi-j-f-marker:before {
    content: "\\e912";
}

.hmi-j-e-marker:before {
    content: "\\e913";
}

.hmi-j-print:before {
    content: "\\e914";
}

.hmi-j-export:before {
    content: "\\e915";
}

.hmi-j-zoom-in:before {
    content: "\\e901";
}

.hmi-j-zoom-out:before {
    content: "\\e902";
}

.hmi-j-zoom-cancel:before {
    content: "\\e903";
}

.hmi-j-table:before {
    content: "\\e904";
}

.hmi-j-select-data:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.hmi-j-tree:before {
    content: "\\e91d";
}

.hmi-j-reset_settings:before {
    content: "\\e926";
}

.hmi-j-inerval_mode:before {
    content: "\\e927";
}

.hmi-j-inerval_go:before {
    content: "\\e928";
}

.hmi-j-inerval_stop:before {
    content: "\\e929";
}

.hmi-j--ackall:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

:host ul {
    list-style-type: none;
    margin: 1em;
    padding: 0;
    user-select: none;
    white-space: nowrap;
    overflow-y: auto;
}

:host ul li input:disabled + label {
    color: rgba(204, 204, 204, 1); /* Из-за hex-цветов alt-linux не может распечатать журнал */
}

.btn {
    margin: 2px;
}

    .btn:hover {
        background-color: rgba(44, 111, 215, 0.04);
    }

    .btn.active {
        background-color: rgba(44, 111, 215, 0.32);
    }

button.ack,
.windowIdLinkBtn {
    background: linear-gradient(180deg, rgba(44, 111, 215, 1) 0%, rgba(52, 90, 164, 1) 100%);
    border: 0.5px solid rgba(52, 90, 164, 1);
    box-sizing: border-box;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    color: white;
    font-family: sans-serif;
    font-size: 12px;
    padding: 0 6px 2px 6px;
}

    button.ack:disabled,
    .windowIdLinkBtn:disabled {
        background: linear-gradient(180deg, rgba(158, 158, 158, 1) 0%, rgba(128, 128, 128, 1) 100%);
        border: 0.5px solid rgba(158, 158, 158, 1);
        color: rgba(199, 199, 199, 1);
        box-shadow: unset;
    }

    button.ack:hover,
    .windowIdLinkBtn:hover {
        background: linear-gradient(180deg, rgba(21, 134, 210, 1) 0%, rgba(45, 108, 207, 1) 100%);
    }

    button.ack:disabled:hover,
    .windowIdLinkBtn:disabled:hover {
        background: linear-gradient(180deg, rgba(158, 158, 158, 1) 0%, rgba(128, 128, 128, 1) 100%);
    }

th {
    user-select: none;
}

    th div {
        pointer-events: none;
    }

    th > div {
        display: flex;
        align-items: center;
        justify-content: center;
    }

        th > div > div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        th > div > .btn {
            font-size: medium;
            pointer-events: auto;
        }

            th > div > .btn.disable {
                color: lightgray;
                pointer-events: none;
            }

.bookmarksList {
    user-select: none;
    display: flex;
    margin: 3px;
    cursor: pointer;
    text-align: start;
}

    .bookmarksList:hover {
        background-color: rgba(44, 111, 215, 0.32);
    }

    .bookmarksList > button {
        visibility: hidden;
    }

    .bookmarksList:hover > button {
        visibility: visible;
    }

thead {
    position: relative;
    z-index: 1;
}

thead th { /* Лучше применять к th, а не tr, поскольку могут возникнуть проблемы с поддержкой браузерами position: sticky для tr */
    position: sticky;
    top: 0;
}

@keyframes flash {
    0% {
        background-color: transparent
    }

    50% {
        background-color: var(--bg-color)
    }

    100% {
        background-color: transparent
    }
}

.hidden {
    visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/controls/journal/style.css"],"names":[],"mappings":"AAAA;;IAEI,+EAA+E;IAC/E,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,gDAA+b;AACnc;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAsb;AAC1b;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAA6iB;AACjjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAkf;AACtf;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B,EAAE,2DAA2D;AAC9F;;AAEA;IACI,WAAW;AACf;;IAEI;QACI,0CAA0C;IAC9C;;IAEA;QACI,0CAA0C;IAC9C;;AAEJ;;IAEI,wFAAwF;IACxF,wCAAwC;IACxC,sBAAsB;IACtB,4EAA4E;IAC5E,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;IAEI;;QAEI,2FAA2F;QAC3F,0CAA0C;QAC1C,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;;QAEI,yFAAyF;IAC7F;;IAEA;;QAEI,2FAA2F;IAC/F;;AAEJ;IACI,iBAAiB;AACrB;;IAEI;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;QAEI;YACI,gBAAgB;YAChB,uBAAuB;YACvB,mBAAmB;QACvB;;QAEA;YACI,iBAAiB;YACjB,oBAAoB;QACxB;;YAEI;gBACI,gBAAgB;gBAChB,oBAAoB;YACxB;;AAEZ;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;IAEI;QACI,0CAA0C;IAC9C;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,WAAW,uHAAuH;IAC9H,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["[class^=\"hmi-j-\"],\r\n[class*=\" hmi-j-\"] {\r\n    /* use !important to prevent issues with browser extensions that change fonts */\r\n    font-family: \"hmi\" !important;\r\n    speak: none;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-variant: normal;\r\n    text-transform: none;\r\n    line-height: 1;\r\n    font-size: 24px;\r\n    /* Better Font Rendering =========== */\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.hmi-j--allpage:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='����_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<g>\t\t<path d='M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3.7L12,3.3L9.3,9.6L5.9,6.1\t\t\tL5.1,6.9l4.5,4.5L13,3.7z'/>\t</g></g></svg>\");\r\n}\r\n\r\n.hmi-j-step-down:before {\r\n    content: \"\\e909\";\r\n}\r\n\r\n.hmi-j-step-up:before {\r\n    content: \"\\e90a\";\r\n}\r\n\r\n.hmi-j-up-down:before {\r\n    content: \"\\e90b\";\r\n}\r\n\r\n.hmi-j-find:before {\r\n    content: \"\\e90c\";\r\n}\r\n\r\n.hmi-j-full-screen:before {\r\n    content: \"\\e90d\";\r\n}\r\n\r\n.hmi-j-filter:before {\r\n    content: \"\\e90e\";\r\n}\r\n\r\n.hmi-j-legend:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='����_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'\t width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<g>\t\t<path d='M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3H5v1h8V3z M13,6H5v1h8V6z M13,9H5\t\t\tv1h8V9z'/>\t</g></g></svg>\");\r\n}\r\n\r\n.hmi-j-pause:before {\r\n    content: \"\\e910\";\r\n}\r\n\r\n.hmi-j-play:before {\r\n    content: \"\\e911\";\r\n}\r\n\r\n.hmi-j-f-marker:before {\r\n    content: \"\\e912\";\r\n}\r\n\r\n.hmi-j-e-marker:before {\r\n    content: \"\\e913\";\r\n}\r\n\r\n.hmi-j-print:before {\r\n    content: \"\\e914\";\r\n}\r\n\r\n.hmi-j-export:before {\r\n    content: \"\\e915\";\r\n}\r\n\r\n.hmi-j-zoom-in:before {\r\n    content: \"\\e901\";\r\n}\r\n\r\n.hmi-j-zoom-out:before {\r\n    content: \"\\e902\";\r\n}\r\n\r\n.hmi-j-zoom-cancel:before {\r\n    content: \"\\e903\";\r\n}\r\n\r\n.hmi-j-table:before {\r\n    content: \"\\e904\";\r\n}\r\n\r\n.hmi-j-select-data:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='����_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<g>\t\t<path d='M11,6h-1v2h1V6z M8,6H7v2h1V6z M11,12h-1v2h1V12z M14,6h-1v2h1V6z M14,9h-1v2h1V9z M14,12h-1v2h1V12z M11,9h-1v2h1V9z\t\t\t M5,12H4v2h1V12z M8,9H7v2h1V9z M5,9H4v2h1V9z M15,3V1h-1v2H4V1H3v2H0v14h18V3H15z M17,16H1V4h16V16z M5,6H4v2h1V6z M8,12H7v2h1\t\t\tV12z'/>\t</g></g></svg> \");\r\n}\r\n\r\n.hmi-j-tree:before {\r\n    content: \"\\e91d\";\r\n}\r\n\r\n.hmi-j-reset_settings:before {\r\n    content: \"\\e926\";\r\n}\r\n\r\n.hmi-j-inerval_mode:before {\r\n    content: \"\\e927\";\r\n}\r\n\r\n.hmi-j-inerval_go:before {\r\n    content: \"\\e928\";\r\n}\r\n\r\n.hmi-j-inerval_stop:before {\r\n    content: \"\\e929\";\r\n}\r\n\r\n.hmi-j--ackall:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='����_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<polygon points='11,2.3 8.3,8.6 4.9,5.1 4.1,5.9 8.6,10.4 12,2.7 \t'/>\t<path d='M14,2V0H2v16h2v2h7.7l4.3-4.3V2H14z M3,1h10v10H9v4H3V1z M13,12v0.3L10.3,15H10v-3H13z M15,13.3L11.3,17H5v-1h5.7l3.3-3.3\t\tV3h1V13.3z'/></g></svg>\");\r\n}\r\n\r\n:host ul {\r\n    list-style-type: none;\r\n    margin: 1em;\r\n    padding: 0;\r\n    user-select: none;\r\n    white-space: nowrap;\r\n    overflow-y: auto;\r\n}\r\n\r\n:host ul li input:disabled + label {\r\n    color: rgba(204, 204, 204, 1); /* Из-за hex-цветов alt-linux не может распечатать журнал */\r\n}\r\n\r\n.btn {\r\n    margin: 2px;\r\n}\r\n\r\n    .btn:hover {\r\n        background-color: rgba(44, 111, 215, 0.04);\r\n    }\r\n\r\n    .btn.active {\r\n        background-color: rgba(44, 111, 215, 0.32);\r\n    }\r\n\r\nbutton.ack,\r\n.windowIdLinkBtn {\r\n    background: linear-gradient(180deg, rgba(44, 111, 215, 1) 0%, rgba(52, 90, 164, 1) 100%);\r\n    border: 0.5px solid rgba(52, 90, 164, 1);\r\n    box-sizing: border-box;\r\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);\r\n    border-radius: 2px;\r\n    color: white;\r\n    font-family: sans-serif;\r\n    font-size: 12px;\r\n    padding: 0 6px 2px 6px;\r\n}\r\n\r\n    button.ack:disabled,\r\n    .windowIdLinkBtn:disabled {\r\n        background: linear-gradient(180deg, rgba(158, 158, 158, 1) 0%, rgba(128, 128, 128, 1) 100%);\r\n        border: 0.5px solid rgba(158, 158, 158, 1);\r\n        color: rgba(199, 199, 199, 1);\r\n        box-shadow: unset;\r\n    }\r\n\r\n    button.ack:hover,\r\n    .windowIdLinkBtn:hover {\r\n        background: linear-gradient(180deg, rgba(21, 134, 210, 1) 0%, rgba(45, 108, 207, 1) 100%);\r\n    }\r\n\r\n    button.ack:disabled:hover,\r\n    .windowIdLinkBtn:disabled:hover {\r\n        background: linear-gradient(180deg, rgba(158, 158, 158, 1) 0%, rgba(128, 128, 128, 1) 100%);\r\n    }\r\n\r\nth {\r\n    user-select: none;\r\n}\r\n\r\n    th div {\r\n        pointer-events: none;\r\n    }\r\n\r\n    th > div {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n        th > div > div {\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n        }\r\n\r\n        th > div > .btn {\r\n            font-size: medium;\r\n            pointer-events: auto;\r\n        }\r\n\r\n            th > div > .btn.disable {\r\n                color: lightgray;\r\n                pointer-events: none;\r\n            }\r\n\r\n.bookmarksList {\r\n    user-select: none;\r\n    display: flex;\r\n    margin: 3px;\r\n    cursor: pointer;\r\n    text-align: start;\r\n}\r\n\r\n    .bookmarksList:hover {\r\n        background-color: rgba(44, 111, 215, 0.32);\r\n    }\r\n\r\n    .bookmarksList > button {\r\n        visibility: hidden;\r\n    }\r\n\r\n    .bookmarksList:hover > button {\r\n        visibility: visible;\r\n    }\r\n\r\nthead {\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\nthead th { /* Лучше применять к th, а не tr, поскольку могут возникнуть проблемы с поддержкой браузерами position: sticky для tr */\r\n    position: sticky;\r\n    top: 0;\r\n}\r\n\r\n@keyframes flash {\r\n    0% {\r\n        background-color: transparent\r\n    }\r\n\r\n    50% {\r\n        background-color: var(--bg-color)\r\n    }\r\n\r\n    100% {\r\n        background-color: transparent\r\n    }\r\n}\r\n\r\n.hidden {\r\n    visibility: hidden;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
